import { activeTabScrollIntoView, clickFromHash } from "@sky-it-livedata/common-web-app-utils";
import { heroSlimSticky } from "./utils/lgp-hero";
import { loadClientWidgets } from "./utils/loadClientWidgets";
import { widgets } from "./widgets";
import { checkSprintRaceLabel } from './utils/motogp-sprint-race';

import "@sky-it-livedata/livedata-sports-design-system/lib/styles/stylesheet.min.css";
import { handleLgpTabs } from "./utils/handle-lgp-tabs";

export const initClient = () => loadClientWidgets(widgets);

initClient();

document.addEventListener('DOMContentLoaded', () => {
    heroSlimSticky();
    checkSprintRaceLabel();
    handleLgpTabs();
    activeTabScrollIntoView();
    clickFromHash();
});
